import React, { useEffect, useState } from "react";
import { ValidationMessage } from "../../components/Utils";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import {
  ONE_TO_ONE_EDIT,
  ONE_TO_ONE_UPDATE,
} from "../../routes/routes";
import { toast } from "react-toastify";
import { FBM_UPDATED } from "../../constant/constant";
import Select from "react-select";
import { FullPageLoader } from "../../components/common/Loader";
import { Image } from "react-bootstrap";
import moment from "moment";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_red.css";
import { memberFormSelectStyles } from "../../constant/selectStyles";

const OnetoOneEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [loading, setLoading] = useState(true);

  const initiatedByOptions = [
    { value: 1, label: "From user" },
    { value: 2, label: "To user" },
  ];

  const submit = () => {
    setLoading(true);
    setBtnDisabled(true);
    const requestBody = {
      ...form,
      date: moment(form.date, ["YYYY-MM-DD", "DD/MM/YYYY"]).format("YYYY-MM-DD"),
    };
    axios
      .put(ONE_TO_ONE_UPDATE + id, requestBody, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          toast.success(FBM_UPDATED);
          navigate("/one-to-one");
        }
      })
      .catch((err) => {
        if (err.response?.status === 422) {
          setErrors(err.response.data.error);
          toast.error(err.response.data.msg);
        }
      })
      .finally(() => {
        setLoading(false);
        setBtnDisabled(false);
      });
  };

  useEffect(() => {
    axios
      .get(ONE_TO_ONE_EDIT + id)
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          const d = res.data.data;
          setForm({
            from_user_id: d.from_user_id,
            from_user_name: d.from_user_name || "",
            to_user_id: d.to_user_id,
            to_user_name: d.to_user_name || "",
            initiated_by: d.initiated_by,
            initiated_by_selected:
              initiatedByOptions.find((o) => o.value === Number(d.initiated_by)) ||
              null,
            meet_location: d.meet_location || "",
            date: moment(d.date, ["DD/MM/YYYY", "YYYY-MM-DD"]).format("YYYY-MM-DD"),
            conversation: d.conversation || "",
            cardImage: d.image || "",
            chapter_id: d.chapter_id,
          });
        }
      })
      .finally(() => setLoading(false));
  }, [id]);

  return (
    <div className="content-wrapper">
      <FullPageLoader visible={loading} />
      <div className="container-fluid p-0 mt-0 mb-2">
        <div className="col-lg-12">
          <div className="row">
            <div className="col-lg-6">
              <h5 className="page-title">121s</h5>
              <ol className="breadcrumb">
                <li>
                  <div className="breadcrumb_f">
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="50"
                        height="50"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#212b39"
                        strokeWidth="1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                        <polyline points="9 22 9 12 15 12 15 22"></polyline>
                      </svg>
                    </div>
                    <div>
                      <Link to={"/dashboard"}>
                        <span>Dashboard</span>
                      </Link>
                    </div>
                  </div>
                </li>
                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#212b39"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </li>
                <li>
                  <Link to={"/one-to-one"}>
                    <span>121s List</span>
                  </Link>
                </li>
                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#212b39"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </li>
                <li>
                  <span className="active_breadcrumb">Edit 121s</span>
                </li>
              </ol>
            </div>
            <div className="col-lg-6">
              <div className="pt-btn">
                <Link to={"/one-to-one"}>
                  <button type="button" className="btn btn-dark igoback_btn">
                    <i className="bx bx-exit"></i> back
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex-grow-1">
        <div className="row">
          <div className="col-xl-12">
            <div className="card mb-4">
              <div className="card-header d-flex justify-content-between align-items-center"></div>
              <div className="card-body app-form-fields">
                <form>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label m-0">From User</label>
                        <p className="mb-0">{form.from_user_name || "-"}</p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label m-0">To User</label>
                        <p className="mb-0">{form.to_user_name || "-"}</p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="initiated_by">
                          Initiated By<span className="text-danger">*</span>
                        </label>
                        <Select styles={memberFormSelectStyles}
                          name="initiated_by"
                          isDisabled={true}
                          options={initiatedByOptions}
                          placeholder="Select"
                          value={form.initiated_by_selected || null}
                          onChange={(selected) =>
                            setForm({
                              ...form,
                              initiated_by: selected?.value,
                              initiated_by_selected: selected,
                            })
                          }
                        />
                        <ValidationMessage error={errors} name="initiated_by" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="date">
                          Date<span className="text-danger">*</span>
                        </label>
                        <Flatpickr
                          id="date"
                          className="form-control"
                          placeholder="Select Date"
                          value={form.date || ""}
                          options={{ dateFormat: "Y-m-d" }}
                          onChange={(dates) =>
                            setForm({
                              ...form,
                              date: dates[0]
                                ? moment(dates[0]).format("YYYY-MM-DD")
                                : "",
                            })
                          }
                        />
                        <ValidationMessage error={errors} name="date" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="meet_location">
                          Location<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="meet_location"
                          placeholder="Location"
                          value={form.meet_location || ""}
                          onChange={(e) =>
                            setForm({ ...form, meet_location: e.target.value })
                          }
                        />
                        <ValidationMessage error={errors} name="meet_location" />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="conversation">
                          Conversation<span className="text-danger">*</span>
                        </label>
                        <textarea
                          className="form-control"
                          id="conversation"
                          placeholder="Conversation"
                          rows={3}
                          value={form.conversation || ""}
                          onChange={(e) =>
                            setForm({ ...form, conversation: e.target.value })
                          }
                        />
                        <ValidationMessage error={errors} name="conversation" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="image">
                          Image
                        </label>
                        <input
                          type="file"
                          className="form-control"
                          id="image"
                          accept="image/*"
                          onChange={(e) =>
                            setForm({ ...form, image: e.target.files?.[0] })
                          }
                        />
                        {form.cardImage && (
                          <Image
                            src={form.cardImage}
                            width={100}
                            className="mt-2"
                          />
                        )}
                      </div>
                    </div>

                    <div className="demo-inline-spacing d-flex justify-content-end">
                      <Link to={"/one-to-one"}>
                        <button
                          type="button"
                          className="btn btn-primary iclose_btn"
                        >
                          Close
                        </button>
                      </Link>
                      <button
                        disabled={btnDisabled}
                        type="button"
                        className="btn btn-success isubmit_button"
                        onClick={() => submit()}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OnetoOneEdit;
